import { twMerge } from '@shared/themes';
import { useTranslations } from 'next-intl';
import type { ComponentProps } from 'react';
import type { PrizeTableTooltips, TableRow } from '../../types';
import { MobileTable, Table } from './components';

type ResultsTableProps = ComponentProps<'div'> & {
  data: TableRow[];
  disableFirstRow?: boolean;
  tooltips?: PrizeTableTooltips;
};

function ResultsTable({ data, className, disableFirstRow, tooltips, ...props }: ResultsTableProps) {
  const t = useTranslations('lotteries.results');
  const headers = (Object.keys(data[0]!) as Array<keyof TableRow>).map(header => ({
    label: t(header),
    value: header,
  }));

  const classes = {
    table: twMerge('border border-border rounded-lg overflow-hidden', className),
    desktop: 'hidden md:table',
    mobile: 'md:hidden',
  };

  return (
    <div className={classes.table} {...props}>
      <Table className={classes.desktop} headers={headers} data={data} disableFirstRow={disableFirstRow} tooltips={tooltips} />
      <MobileTable className={classes.mobile} data={data} headers={headers} disableFirstRow={disableFirstRow} tooltips={tooltips} />
    </div>
  );
}

export { ResultsTable };
export type { ResultsTableProps };
